import { useUser } from "@libs:react-query-auth";

import { hasPermission, RBACAction, RBACResource, roles } from "@:rbac";

export const useRBACCheck = (action: RBACAction, resource: RBACResource) => {
  const user = useUser();

  const role = user.data?.role;

  if (!role) return false;

  const permissions = Reflect.get(roles, role);

  if (!permissions) return false;

  return hasPermission(permissions, action, resource);
};
